import _noop from 'lodash/noop';
import { CustomsUserType } from '@packlink/packlink-sdk';
import { getComposedFieldName } from '@packlink/utils';
import { getIn, Field, FastField } from 'formik';
import { FormField, Select, Input } from '@shipengine/formik-giger';
import { Option, FieldMessageType } from '@shipengine/giger';
import { useTranslation } from '@packlink/translation-provider';
import { translateSelectOptions } from '../../../utils/select.js';
import { useCustomsFormData, useCustomsFormContext } from '../../../CustomsFormData.js';
import { jsxs, Fragment, jsx } from '@emotion/react/jsx-runtime';
import { userTaxTypeOptions } from '../../../data/TaxFormTypes.js';

function TaxForm(_ref) {
  var _values$vatStatus;
  let {
    type
  } = _ref;
  const {
    values: formValues
  } = useCustomsFormData();
  const {
    fieldNamePrefix
  } = useCustomsFormContext();
  const values = getIn(formValues, type);
  const {
    t
  } = useTranslation();
  const getFieldName = field => getComposedFieldName(fieldNamePrefix, type, field);
  const selectedVatStatus = (_values$vatStatus = values.vatStatus) === null || _values$vatStatus === void 0 ? void 0 : _values$vatStatus.value;
  const isCompany = selectedVatStatus && selectedVatStatus === CustomsUserType.COMPANY;
  const isPrivatePerson = selectedVatStatus && selectedVatStatus === CustomsUserType.PRIVATE_PERSON;
  const isTaxIdOptional = type === 'receiver';
  const translatedUserTypeOptions = translateSelectOptions(userTaxTypeOptions, t);
  return jsxs(Fragment, {
    children: [jsx(FormField, {
      name: getFieldName('vatStatus'),
      children: jsx(Field, {
        component: Select,
        label: t('customs-form.tax-info.vat-status-label'),
        onClear: _noop,
        children: translatedUserTypeOptions.map(option => jsx(Option, {
          value: option.value,
          children: option.label
        }, option.value))
      })
    }), isCompany && jsxs(Fragment, {
      children: [jsx(FormField, {
        name: getFieldName('company'),
        children: jsx(FastField, {
          component: Input,
          type: "text",
          label: t('customs-form.tax-info.company-label')
        })
      }), jsx(FormField, {
        name: getFieldName('vatNumber'),
        children: jsx(FastField, {
          component: Input,
          type: "text",
          label: t('customs-form.tax-info.vat-number-label')
        })
      }), jsx(FormField, {
        name: getFieldName('eori'),
        message: {
          type: FieldMessageType.HINT,
          content: t('form.hint.optional')
        },
        children: jsx(FastField, {
          component: Input,
          type: "text",
          label: t('customs-form.tax-info.eori-label')
        })
      })]
    }), isPrivatePerson && jsx(FormField, {
      name: getFieldName('taxId'),
      message: isTaxIdOptional ? {
        type: FieldMessageType.HINT,
        content: t('form.hint.optional')
      } : undefined,
      children: jsx(FastField, {
        component: Input,
        type: "text"
        // TODO: This won't be needed after https://packlink.atlassian.net/browse/PS-651
        ,
        label: t(isTaxIdOptional ? 'customs-form.tax-info.optional-tax-id-label' : 'customs-form.tax-info.tax-id-label')
      })
    })]
  });
}

export { TaxForm };
//# sourceMappingURL=TaxForm.js.map
